import {action, computed, observable} from 'mobx';
import {isMidi} from "../utils/audioUtility";

class AudioStore {
    @observable trackUrl = null;
    @observable audio = null;
    @observable played = false;
    @observable isMidiFile = false;

    @action createAudioUrl = (file) => {
        if (isMidi(file.type)) {
            this.isMidiFile = true;
        } else {
            this.trackUrl = URL.createObjectURL(file);
            this.played = false;
        }
    };

    @action deleteAudio = () => {
        this.trackUrl = null;
        this.played = false;
    };

    @action setAudioRef = (audio) => {
        this.audio = audio;
    };

    @action play = () => {
        if (!this.audio) {
            return;
        }
        this.audio.play();
        this.played = true;
    };

    @action stop = () => {
        if (!this.audio) {
            return;
        }
        this.audio.pause();
        this.audio.currentTime = 0;
        this.played = false;
    };

    @computed
    get isPlayed() {
        return this.played;
    }

    togglePlay = () => {
        if (!this.audio) {
            return;
        }
        if (this.played) {
            this.stop();
        } else {
            this.play();
        }
    };
}

const audioStore = new AudioStore();
export default audioStore;
